export const INSERT_DEEP_LINK_PARAMETERS = 'INSERT_DEEP_LINK_PARAMETERS';
export const RESET_DEEP_LINK_PARAMETERS = 'RESET_DEEP_LINK_PARAMETERS';
